var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 39,
    viewBox: "0 0 32 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.2501C30 30.0001 23.875 34.3751 16.595 36.9126C16.2138 37.0417 15.7997 37.0356 15.4225 36.8951C8.125 34.3751 2 30.0001 2 21.2501V9.00005C2 8.53593 2.18437 8.09081 2.51256 7.76262C2.84075 7.43443 3.28587 7.25005 3.75 7.25005C7.25 7.25005 11.625 5.15005 14.67 2.49005C15.0407 2.1733 15.5124 1.99927 16 1.99927C16.4876 1.99927 16.9593 2.1733 17.33 2.49005C20.3925 5.16755 24.75 7.25005 28.25 7.25005C28.7141 7.25005 29.1592 7.43443 29.4874 7.76262C29.8156 8.09081 30 8.53593 30 9.00005V21.2501Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.fec5405fe0269aef71af550b3ad0034c.svg";
export { ForwardRef as ReactComponent };